import PropTypes from "prop-types";
import SeasonPredictionfile from "../data/RankPrediction.json";
import styles from "./Chart.module.css";
import rankLine from "../global/RankLine.json";
import { smooth } from "../global/floatColor";

function Chart({ league, stage, team, language }) {
  const dict = SeasonPredictionfile[league].find(
    (element) => element.key === stage
  ).value;
  const datum =
    team in dict ? dict[team] : Array(Object.values(dict)[0].length).fill(0);
  const len = datum.length;
  const left = datum[0] > datum[len - 1];
  return [
    <svg
      className={styles.horizontal}
      viewBox={left ? "-5 0 104.5 60" : "0.5 0 104.5 60"}
      key="horizontal_svg"
    >
      <line
        x1="100"
        x2="100"
        y1="0"
        y2="50"
        style={{ stroke: "black", strokeWidth: 0.1 }}
      />
      <line
        x1="0"
        x2="100"
        y1="50"
        y2="50"
        style={{ stroke: "black", strokeWidth: 0.1 }}
      />
      <line
        x1="0"
        x2="0"
        y1="0"
        y2="50"
        style={{ stroke: "black", strokeWidth: 0.1 }}
      />
      {/* <line
        x1="0"
        x2="100"
        y1="25"
        y2="25"
        style={{ stroke: "black", strokeWidth: 0.1 }}
      />
      <line
        x1="0"
        x2="100"
        y1="0"
        y2="0"
        style={{ stroke: "black", strokeWidth: 0.2 }}
      /> */}
      <text x={-2.5} y={50} fontSize={2} textAnchor="middle">
        0%
      </text>
      <text x={-2.5} y={26} fontSize={2} textAnchor="middle">
        50%
      </text>
      <text x={-2.5} y={2} fontSize={2} textAnchor="middle">
        100%
      </text>
      <text x={102.5} y={50} fontSize={2} textAnchor="middle">
        0%
      </text>
      <text x={102.5} y={26} fontSize={2} textAnchor="middle">
        50%
      </text>
      <text x={102.5} y={2} fontSize={2} textAnchor="middle">
        100%
      </text>
      {datum.map((data, idx) => {
        return (
          <rect
            x={(100 / len) * idx + 1}
            y={50 - data * 50}
            key={(team, idx)}
            width={100 / len - 2}
            height={data * 50}
            className={styles.rect}
          />
        );
      })}
      {rankLine[league][stage].cut_line.map((cut, idx) => {
        //if (idx + 1 === rankLine[league][stage].cut_line.length) return null;
        if (Array.isArray(cut))
          cut = cut[0] - (cut.length > 1 && cut[0] < cut[1]);
        return (
          <line
            x1={(100 / len) * cut}
            x2={(100 / len) * cut}
            y1="0"
            y2="59"
            key={("line", idx)}
            style={{ stroke: "gray", strokeWidth: 0.1 }}
          />
        );
      })}
      {rankLine[league][stage].title[language].map((txt, idx) => {
        // if (idx + 1 === rankLine[league][stage].cut_line.length) return null;
        let cut = rankLine[league][stage].cut_line[idx];
        if (Array.isArray(cut)) {
					if(cut.length > 1)
						cut = cut[0] - (cut[1] && cut[0] < cut[1]);
					else cut = cut[0];
				}
        return (
          <text
            key={("title", idx)}
            x={(100 / len) * cut + 1}
            y={(rankLine[league][stage].cut_line.length - idx) * 3}
            fontSize={2}
            textAnchor="begin"
          >
            {txt}
          </text>
        );
      })}
      {datum.map((data, idx) => [
        <text
          x={(100 / len) * (idx + 0.5)}
          y={53}
          key={`rank_${team}_${idx}`}
          fontSize={2}
          textAnchor="middle"
        >
          {idx + 1}위
        </text>,
        ((stage === "CS1" || stage === "CS2") && idx > 5) ||
        (stage === "WQ" && idx > 3) ? null : (
          <text
            x={(100 / len) * (idx + 0.5)}
            y={57}
            key={`percent_${team}_${idx}`}
            fontSize={league === "LPL" ? 1.8 : 2}
            textAnchor="middle"
          >
            {smooth(data)}%
          </text>
        ),
      ])}
    </svg>,
    <svg
      className={styles.vertical}
      viewBox={left ? "0 -5 60 104.5" : "0 0.5 60 104.5"}
      key="vertical_svg"
    >
      <line
        y1="100"
        y2="100"
        x1="10"
        x2="60"
        style={{ stroke: "black", strokeWidth: 0.1 }}
      />
      <line
        y1="0"
        y2="100"
        x1="10"
        x2="10"
        style={{ stroke: "black", strokeWidth: 0.1 }}
      />
      <line
        y1="0"
        y2="0"
        x1="10"
        x2="60"
        style={{ stroke: "black", strokeWidth: 0.1 }}
      />
      {/* <line
        x1="0"
        x2="100"
        y1="25"
        y2="25"
        style={{ stroke: "black", strokeWidth: 0.1 }}
      />
      <line
        x1="0"
        x2="100"
        y1="0"
        y2="0"
        style={{ stroke: "black", strokeWidth: 0.2 }}
      /> */}
      <text y={-2.5} x={57} fontSize={2} textAnchor="middle">
        100%
      </text>
      <text y={-2.5} x={34} fontSize={2} textAnchor="middle">
        50%
      </text>
      <text y={-2.5} x={11} fontSize={2} textAnchor="middle">
        0%
      </text>
      <text y={102.5} x={57} fontSize={2} textAnchor="middle">
        100%
      </text>
      <text y={102.5} x={34} fontSize={2} textAnchor="middle">
        50%
      </text>
      <text y={102.5} x={11} fontSize={2} textAnchor="middle">
        0%
      </text>
      {datum.map((data, idx) => {
        return (
          <rect
            y={(100 / len) * idx + 1}
            x={10}
            key={(team, idx)}
            height={100 / len - 2}
            width={data * 50}
            className={styles.rect}
          />
        );
      })}
      {rankLine[league][stage].cut_line.map((cut, idx) => {
        // if (idx + 1 === cut_line[league].length) return null;
        if (Array.isArray(cut))
          cut = cut[0] - (cut[1] !== undefined && cut[0] < cut[1]);
        return (
          <line
            y1={(100 / len) * cut}
            y2={(100 / len) * cut}
            x1="0"
            x2="59"
            key={("cut_line", idx)}
            style={{ stroke: "gray", strokeWidth: 0.1 }}
          />
        );
      })}
      {rankLine[league][stage].title[language].map((txt, idx) => {
        // if (idx + 1 === cut_line[league].length) return null;
        let cut = rankLine[league][stage].cut_line[idx];
        if (Array.isArray(cut))
          cut = cut[0] - (cut[1] !== undefined && cut[0] < cut[1]);
        return (
          <text
            key={("title", idx)}
            y={(100 / len) * cut + 2}
            x={59}
            fontSize={2}
            textAnchor="end"
          >
            {txt}
          </text>
        );
      })}
      {datum.map((data, idx) => [
        <text
          y={(100 / len) * (idx + 0.5)}
          x={2}
          key={`rank_${team}_${idx}`}
          fontSize={2}
          textAnchor="middle"
        >
          {idx + 1}
          {language === "kr"
            ? "위"
            : idx === 0
            ? "st"
            : idx === 1
            ? "nd"
            : idx === 2
            ? "rd"
            : "th"}
        </text>,
        <text
          y={(100 / len) * (idx + 0.5)}
          x={7}
          key={`percent_${team}_${idx}`}
          fontSize={1.8}
          textAnchor="middle"
        >
          {smooth(data)}%
        </text>,
      ])}
    </svg>,
  ];
}

Chart.propTypes = {
  league: PropTypes.string.isRequired,
  team: PropTypes.string.isRequired,
  stage: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

export default Chart;
